
<div class="ipm-coupon-list-section">
    <div class="ipm-heading-model-section">
        <div class="ipm-close-icon" (click)="closeByDeviceType()">
            <i class="pi pi-times"></i>
        </div>
    </div>
    <div class="ipm-coupon-list-body">
        <div class="ipm-coupon-input-section">
            <div class="custom-form">
                <div class="form-group custom-form-group">
                    <input type="text"
                        class="form-control"
                        id="coupons"
                        name="couponsValue"
                        [(ngModel)]="couponCode"
                        [ngModelOptions]="{standalone: true}"
                        (keyup.enter)="applyCoupon()"
                        autocomplete="off"
                        placeholder="Enter Coupon">
                </div>
            </div>
            <div class="coupon-btn-section">
                <button class="btn btn-coupon" [disabled]="!couponCode" (click)="applyCoupon()"> Apply</button>
            </div>
        </div>
        <div class="ipm-available-coupons">
            <ng-container *ngFor="let couponObj of couponList">
                <div class="coupon-section" (click)="closeByDeviceType('widthData', couponObj)">
                    <div class="ipm-coupon-radius ipm-position-left"></div>
                    <div class="coupon-code">
                        {{couponObj?.code}}
                    </div>
                    <div class="coupon-info-sec">
                        <span class="applicable-beats-list">
                            Applicable on
                            <span class="coupons-beat-list">
                                <ng-container *ngIf="couponObj?.beats && couponObj.beats.length > 0">
                                    <ng-container *ngFor="let beatObj of couponObj?.beats; let j = index">
                                        <div class="image-wrapper" *ngIf="j < 4">
                                            <img priority [src]="beatObj.beat_cover_Image" alt="coupons-beat-img" width="14" height="14">
                                        </div>
                                    </ng-container>
                                    <div class="image-wrapper ipm-total-beats" *ngIf="couponObj.beats.length > 4">
                                        +{{couponObj.beats.length - 4}}
                                    </div>
                                </ng-container>
                            </span>
                        </span>
                        <span class="applicable-beats-name">
                            {{couponObj.beats[0].beat_name}}  <span *ngIf="couponObj.beats.length > 1">
                                +{{couponObj.beats.length - 1}} more beats
                            </span>
                        </span>
                        <span class="coupon-percentage">
                            {{couponObj.discount.quantifier === "percentage" ?
                            ((couponObj.discount.value / 100) | percent ) + ' off' :
                            (couponObj.discount.value | currency : 'INR' : 'symbol' : '0.0-0' )  }}
                        </span>
                    </div>
                    <div class="ipm-coupon-radius ipm-position-right"></div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
